import RedButton from '@/components/atoms/RedButton';
import Styles from './CanaisAtendimentoQrcode.css';
import React from 'react';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function CanaisAtendimentoQrcode() {
  return (
    <>
      <section id="canais-atendimento-qrcode">
        <p className="canais-atendimento-paragrafo">
          Em nosso WhatsApp você encontra informações com agilidade e diversos serviços para tornar
          o seu dia a dia mais fácil.{' '}
          <div className="only-desk">
            Utilize o WhatsApp Web pelo botão abaixo ou leia o QR Code ao lado com seu celular.
          </div>
          <div className="only-mobile">
            Clique no botão abaixo e utilize todas as funcionalidades disponíveis!
          </div>{' '}
          Se preferir o número do WhatsApp é o <b>(11) 4004-9090</b>.
        </p>
        <img
          className="canais-atendimento-qrcode"
          src="assets/canais-de-atendimento/qrcode-whatsapp.png"
          alt="Qr code whatsapp santander"
        />
        <RedButton
          className="canais-atendimento-btn"
          href="https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
          target="_blank"
        >
          Ir para Whatsapp
        </RedButton>
      </section>

      <section id="canais-atendimento-servicos">
        <div className="is-mob">
          <CustomEmblaCarouselHome24
            enableBullets
            bulletCount={5}
            enableMobileArrows
            enablePrevArrow
            hideOverflow
          >
            {({ className }) => (
              <>
                <div className={`canais-slide ${className}`}>
                  <div className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_barcode.svg"
                        alt="ícone Boletos"
                      />
                      <b className="canais-conteudos-negrito">Boletos</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Gerar 2ª do boleto de sua parcela de financiamento, de atualização ou
                      quitação.
                    </p>
                  </div>
                </div>
                <div className={`canais-slide ${className}`}>
                  <div className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_bank_renegotiation.svg"
                        alt="ícone Renegociação"
                      />
                      <b className="canais-conteudos-negrito">Renegociação</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Entenda como renegociar ou aumentar o prazo e diminuir parcelas.
                    </p>
                  </div>
                </div>
                <div className={`canais-slide ${className}`}>
                  <a href="#" target="_blank" className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_bank_financing.svg"
                        alt="ícone Empréstimo pessoal"
                      />
                      <b className="canais-conteudos-negrito">Empréstimo pessoal</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Receba informações sobre simulação e contratação.
                    </p>
                  </a>
                </div>
                <div className={`canais-slide ${className}`}>
                  <div className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                        alt="ícone Alterar forma de pagamento"
                      />
                      <b className="canais-conteudos-negrito">Alterar forma de pagamento</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Você pode alterar sua forma de pagamento para débito em conta e receber
                      cashback em suas parcelas.
                    </p>
                  </div>
                </div>
                <div className={`canais-slide ${className}`}>
                  <div className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_document_contract.svg"
                        alt="ícone Contrato"
                      />
                      <b className="canais-conteudos-negrito">Contrato</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Saiba como acessar o seu contrato sempre que precisar.
                    </p>
                  </div>
                </div>
                <div className={`canais-slide ${className}`}>
                  <div className="canais-conteudos-card">
                    <div className="content-card">
                      <img
                        className="img-card"
                        src="assets/canais-de-atendimento/ic_internet_banking.svg"
                        alt="ícone Área do Cliente"
                      />
                      <b className="canais-conteudos-negrito">Área do Cliente</b>
                    </div>

                    <p className="canais-conteudos-slide-titulo">
                      Consulte todos os serviços disponíveis em seu acesso na Santander
                      Financiamentos.
                    </p>
                  </div>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
          <div className="canais-atendimento-content-wpp">
            <img
              className="canais-atendimento-img"
              src="assets/canais-de-atendimento/wpp_acesso.svg"
              alt="conversa pelo whatsapp com santander"
            />
            <img
              className="canais-atendimento-img"
              src="assets/canais-de-atendimento/wpp-serviços.svg"
              alt="gerando boleto"
            />
          </div>
          {/* <img
            className="area-cliente-santander-img"
            src="assets/canais-de-atendimento/santander-symbol-new.svg"
            alt="logo santander"
          /> */}
        </div>

        <div className="is-desk">
          <div className="content-desk">
            <div className="canais-atendimento-content-servicos">
              <div className={`canais-slide`}>
                <div className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_barcode.svg"
                      alt="ícone Boletos"
                    />
                    <b className="canais-conteudos-negrito">Boletos</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Gerar 2ª do boleto de sua parcela de financiamento, de atualização ou quitação.
                  </p>
                </div>
              </div>
              <div className={`canais-slide`}>
                <div className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_bank_renegotiation.svg"
                      alt="ícone Renegociação"
                    />
                    <b className="canais-conteudos-negrito">Renegociação</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Entenda como renegociar ou aumentar o prazo e diminuir parcelas.
                  </p>
                </div>
              </div>
              <div className={`canais-slide`}>
                <a href="#" target="_blank" className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_bank_financing.svg"
                      alt="ícone Empréstimo pessoal"
                    />
                    <b className="canais-conteudos-negrito">Empréstimo pessoal</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Receba informações sobre <br />
                    simulação e contratação.
                  </p>
                </a>
              </div>
              <div className={`canais-slide`}>
                <div className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                      alt="ícone Alterar forma de pagamento"
                    />
                    <b className="canais-conteudos-negrito">Alterar forma de pagamento</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Você pode alterar sua forma de pagamento para débito em conta e receber cashback
                    em suas parcelas.
                  </p>
                </div>
              </div>
              <div className={`canais-slide`}>
                <div className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_document_contract.svg"
                      alt="ícone Contrato"
                    />
                    <b className="canais-conteudos-negrito">Contrato</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Saiba como acessar o seu contrato sempre que precisar.
                  </p>
                </div>
              </div>
              <div className={`canais-slide`}>
                <div className="canais-conteudos-card">
                  <div className="content-card">
                    <img
                      className="img-card"
                      src="assets/canais-de-atendimento/ic_internet_banking.svg"
                      alt="ícone Área do Cliente"
                    />
                    <b className="canais-conteudos-negrito">Área do Cliente</b>
                  </div>

                  <p className="canais-conteudos-slide-titulo">
                    Consulte todos os serviços disponíveis em seu acesso na Santander
                    Financiamentos.
                  </p>
                </div>
              </div>
            </div>
            <div className="canais-atendimento-content-imgs">
              <img
                className="canais-atendimento-img"
                src="assets/canais-de-atendimento/wpp_acesso.svg"
                alt="conversa pelo whatsapp com santander"
              />
              <img
                className="canais-atendimento-img"
                src="assets/canais-de-atendimento/wpp-serviços.svg"
                alt="gerando boleto"
              />
            </div>
          </div>
          {/* <img
            className="area-cliente-santander-img"
            src="assets/canais-de-atendimento/santander-symbol-new.svg"
            alt="logo santander"
          /> */}
        </div>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CanaisAtendimentoQrcode;
